export default __webpack_public_path__ + "static/media/WeeDeliver_Cp_background.9da104ba.jpg";